import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './SrInitialsCircle.less';

import getUserNameInitials from 'common/util/getUserNameInitials';

export const SR_INITIALS_CIRCLE_THEME_YELLOW = 'SR_INITIALS_CIRCLE_THEME_YELLOW';
export const SR_INITIALS_CIRCLE_THEME_PURPLE = 'SR_INITIALS_CIRCLE_THEME_PURPLE';
const SR_INITIALS_CIRCLE_THEME_TO_CLASSNAME_MAPPING = {
  [SR_INITIALS_CIRCLE_THEME_YELLOW]: 'initials-circle-yellow',
  [SR_INITIALS_CIRCLE_THEME_PURPLE]: 'initials-circle-purple',
};
const SR_INITIALS_CIRCLE_THEMES = Object.keys(SR_INITIALS_CIRCLE_THEME_TO_CLASSNAME_MAPPING);

const SrInitialsCircle = ({ name, theme, hasBorder }) => (
  <div
    styleName={classnames(
      'SrInitialsCircle',
      SR_INITIALS_CIRCLE_THEME_TO_CLASSNAME_MAPPING[theme],
      { hasBorder },
    )}
  >
    <span>{getUserNameInitials(name)}</span>
  </div>
);

SrInitialsCircle.propTypes = {
  name: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(SR_INITIALS_CIRCLE_THEMES),
};

SrInitialsCircle.defaultProps = {
  theme: SR_INITIALS_CIRCLE_THEME_PURPLE,
};

SrInitialsCircle.displayName = 'SrInitialsCircle';

export default SrInitialsCircle;
